import { Stack, Typography } from '@mui/material';

import colors from '../../../../constants/colors';
import PaymentStatusChip from './PaymentStatusChip';

interface ReviewCardCommonEntryProps {
  label: string;
  text: string | JSX.Element;
  failed?: boolean;
  className?: string;
}

const ReviewCardCommonEntry = ({
  label,
  text,
  className,
  failed,
}: ReviewCardCommonEntryProps) => (
  <Stack spacing={0.5}>
    <Stack direction="row" justifyContent="space-between">
      <Typography
        sx={{
          fontFamily: 'Cabin',
          fontKerning: 'normal',
          fontWeight: 700,
          fontSize: { mobile: 16, tablet: 18 },
          lineHeight: '24px',
        }}
      >
        {label}
      </Typography>
      {failed !== undefined && <PaymentStatusChip failed={failed} />}
    </Stack>
    <Typography
      className={className}
      sx={{
        fontFamily: 'Cabin',
        fontKerning: 'normal',
        fontWeight: 400,
        fontSize: { mobile: 16, tablet: 18 },
        lineHeight: '24px',
        color: colors.csaaMid,
      }}
    >
      {text}
    </Typography>
  </Stack>
);

export default ReviewCardCommonEntry;
